import { render, staticRenderFns } from "./ClassMarkDataTable.vue?vue&type=template&id=cdf23564&scoped=true"
import script from "./ClassMarkDataTable.vue?vue&type=script&lang=js"
export * from "./ClassMarkDataTable.vue?vue&type=script&lang=js"
import style0 from "./ClassMarkDataTable.vue?vue&type=style&index=0&id=cdf23564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf23564",
  null
  
)

export default component.exports